import React from 'react'
import { Route } from 'react-router-dom'
import { Crumbs } from '../components/Crumbs'

// Wrap router for passing props to child components.
export const PropRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={routeProps => {
            return (
                <>
                    <h1 className={'content-title'}>{rest.data.name}</h1>
                    <Crumbs {...rest} {...routeProps} />
                    <Component data={rest.data} {...routeProps} />
                </>
            )
        }}
    />
)
